import React from "react";
import { Table } from "react-bootstrap";
import { formatTime } from "../../utils/timeUtils.js";

// times: flat array of time objects, chunked into rows inside this component
// service: string to display as a table header
function toTitleCase(str) {
  if (!str) return '';
  return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
}

export default function StopTimetable({ times, rowSize = 6, service }) {
  if (!Array.isArray(times) || times.length === 0) return null;

  const rows = [];
  // chunk times into rows of rowSize
  for (let i = 0; i < times.length; i += rowSize) {
    rows.push(times.slice(i, i + rowSize));
  }

  return (
    <Table bordered size="sm" className="text-center">
      {service && (
        <thead>
          <tr>
            <th colSpan={rowSize}>{toTitleCase(service)}</th>
          </tr>
        </thead>
      )}
      <tbody>
        {rows.map((row, i) => (
          <tr key={i}>
            {row.map((t, j) => {
              // Legacy `time` is already a Pacific label; normalize raw clock/datetime fallbacks.
              const time = t?.time || formatTime(t?.departure_time || t?.arrival_time);
              return (
                <td key={j}>
                  {t?.tags?.includes("bold") ? <strong>{time}</strong> : time}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
